<!-- src/components/icons/DarkDataIcon.vue -->

<script setup lang="ts">
import { computed } from 'vue'

/**
 * Props for controlling logo appearance.
 * - opacity: 0 (transparent) to 1 (opaque)
 * - brightness: 0 (black) to 2 (double bright), default 1 (normal)
 * - size: pixel size for width/height (default 64)
 * - ariaLabel: accessibility label
 * - title: hover text for the icon
 */
const props = defineProps<{
  opacity?: number
  brightness?: number
  size?: number
  ariaLabel?: string
  title?: string
}>()

const svgOpacity = computed(() =>
  typeof props.opacity === 'number'
    ? Math.max(0, Math.min(1, props.opacity))
    : 1
)

const svgBrightness = computed(() =>
  typeof props.brightness === 'number'
    ? Math.max(0, props.brightness)
    : 1
)

const svgSize = computed(() =>
  typeof props.size === 'number' && props.size > 0
    ? props.size
    : 64
)

const ariaLabel = computed(() =>
  props.ariaLabel || 'DakrData logo'
)

const hoverTitle = computed(() =>
  props.title || 'DarkData logo"'
)
</script>

<template>
  <svg
    :width="svgSize"
    :height="svgSize"
    viewBox="0 0 100 75"
    xmlns="http://www.w3.org/2000/svg"
    :aria-label="DarkData"
    :title="DarkData"
    role="img"
    preserveAspectRatio="xMidYMid meet"
    :style="{
      opacity: svgOpacity,
      filter: `brightness(${svgBrightness})`
    }"
    class="block"
  >
    <path
      fill="#246bfd"
      d="m16 0 68.49-.045-.07 33.895-34.29 23.585-19.47-12.81.09-22.375h-7v26l26.39 17.07 34.263-22.288-.007 9.307-34.297 22.563L16 52q-.007-30.305 0-37.25l53.505.085Q69.462 31.2 69.5 34.75l6-4 .05-23.25H16zm27.75 24.5c-1.597 1.998-2.185 4.265-1.913 6.813.507 2.388 1.395 3.91 3.395 5.32L46 37l-1.985 8.6 11.735-.1A929 929 0 0 0 54 37l1.032-.225c1.698-.87 3.623-3.678 3.82-5.61.235-2.377.383-4.6-.945-6.655-2.445-3.558-4.885-3.47-7.65-3.313-3.14.253-4.298.81-6.508 3.305"
    />
  </svg>
</template>
